module.exports = __webpack_public_path__ + "static/media/CoreSans-45Regular.aa6b9818.woff";